import axios from 'axios'
import {Message} from 'element-ui';
import router from '../router'
import {mymessage} from '@/utils/mymessage.js';
import Cookies from "js-cookie";
import store from "../store";


axios.interceptors.response.use(success => {
    if (success.resultCode && success.resultCode == 200 && success.resultCode == 500) {
        Message.error({message: success.resultDesc})
        return;
    }

    if(success.data.resultCode && success.data.resultCode ==1888) {
      Message.error({message: "登录状态已过期，请重新登录"});
      store.dispatch('LogOut').then(() => {
        location.href = '/index';
      })
    }
    if (success.resultDesc) {
        Message.success({message: success.resultDesc})
    }
    return success.data;
}, error => {
    if (error.response.resultCode == 504 || error.response.resultCode == 404) {
        Message.error({message: '服务器开小窗了,请稍侯再试( ╯□╰ )'})
    } else if (error.response.resultCode == 403) {
        Message.error({message: '权限不足，请联系管理员'})
    } else if (error.response.resultCode == 401) {
        mymessage.error({message: error.response.resultDesc ? error.response.resultDesc : '尚未登录，请登录'})
      Message.error({message: '权限不足，请联系管理员'})
        router.replace('/');
    }else if (error.response.resultCode == 1888) {

      Message.error({message: "登录状态已过期，请重新登录"});
      store.dispatch('LogOut').then(() => {
        location.href = '/index';
      })

    } else {
        if (error.response.resultDesc) {
            Message.error({message: error.response.data.resultDesc})
        } else {
            Message.error({message: '未知错误!'})
        }
    }
    return;
})

// http request 拦截器
axios.interceptors.request.use(
  config => {
    config.headers.token = Cookies.get('token');
    config.headers['Content-Type'] = 'application/json;charset=utf-8;';
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

let base = process.env.BASE_API;

export const postKeyValueRequest = (url, params) => {
    return axios({
        method: 'post',
        url: `${base}${url}`,
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let i in data) {
                ret += encodeURIComponent(i) + '=' + encodeURIComponent(data[i]) + '&'
            }
            return ret;
        }],
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
}
export const postRequest = (url, params) => {
    return axios({
        method: 'post',
        url: `${base}${url}`,
        data: params
    })
}
export const putRequest = (url, params) => {
    return axios({
        method: 'put',
        url: `${base}${url}`,
        data: params
    })
}
export const getRequest = (url, params) => {
    return axios({
        method: 'get',
        url: `${base}${url}`,
        params: params
    })
}
export const deleteRequest = (url, params) => {
    return axios({
        method: 'delete',
        url: `${base}${url}`,
        params: params
    })
}



// WEBPACK FOOTER //
// ./src/utils/api.js